import * as React from 'react';

const FlagBR = (props: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		xmlSpace="preserve"
		viewBox="0 0 512 512"
		{...props}
	>
		<defs>
			<clipPath id="a">
				<circle r={735} />
			</clipPath>
		</defs>
		<circle
			cx={256}
			cy={256}
			r={256}
			style={{
				fill: '#009b3a',
				fillOpacity: 1,
				stroke: 'none',
				strokeWidth: 389.50588989,
				strokeMiterlimit: 4,
				strokeDasharray: 'none',
				strokeOpacity: 1,
			}}
		/>
		<g transform="matrix(.81034 0 0 .81034 60.86 43.28)">
			<rect
				width="17.143%"
				height="17.143%"
				x={240.814}
				y={262.508}
				style={{
					display: 'inline',
					fill: '#009b3a',
					strokeWidth: 0.17142858,
				}}
			/>
			<path
				d="m-57.986 262.508 298.8 190.8 298.8-190.8-298.8-190.8z"
				style={{
					display: 'inline',
					fill: '#fedf00',
					strokeWidth: 0.17142858,
				}}
			/>
			<circle
				cx={240.814}
				cy={262.508}
				r={126}
				style={{
					fill: '#002776',
					strokeWidth: 0.17142858,
				}}
			/>
			<path
				d="M-2205 1470a1785 1785 0 0 1 3570 0h-105a1680 1680 0 1 0-3360 0z"
				clipPath="url(#a)"
				style={{
					fill: '#fff',
				}}
				transform="matrix(.17143 0 0 .17143 240.814 262.508)"
			/>
			<g
				style={{
					fill: '#009b3a',
				}}
			>
				<path
					d="M-206.873-1684.847a35 31.5 83 0 0-8.531-69.478 35 31.5 83 0 0 8.53 69.478m-1.584-12.903a22 18.5 83 0 0-5.362-43.672 22 18.5 83 0 0 5.362 43.672"
					style={{
						fillRule: 'evenodd',
					}}
					transform="matrix(.17143 0 0 .17143 168.814 514.508)"
				/>
				<path
					d="M-31.5 0h13v-26h28a22 22 0 0 0 0-44h-40zm13-39h27a9 9 0 0 0 0-18h-27z"
					style={{
						fillRule: 'evenodd',
					}}
					transform="rotate(-4.007 3284.884 -2013.956) scale(.17143)"
				/>
				<path d="M153.303 223.883c-.12-1.71-.383-5.473-2.948-5.293l-3.25.227c3.763-.263 4.026 3.499 4.146 5.209" />
				<path
					d="m-61.12-1696.692 32.994-.576a30 30 0 0 0 29.472-30.519l-.174-9.998a30 30 0 0 0-30.52-29.472l-32.994.576zm12.77-13.225 18.998-.331a19 19 0 0 0 18.665-19.329l-.105-5.999a19 19 0 0 0-19.328-18.666l-18.997.332z"
					style={{
						fillRule: 'evenodd',
					}}
					transform="matrix(.17143 0 0 .17143 168.814 514.508)"
				/>
				<path d="m173.573 223.497 10.793.377.078-2.227-8.738-.305.108-3.084 6.853.24.072-2.057-6.853-.239.084-2.398 8.223.287.078-2.227-10.28-.36zM188.796 224.145l2.05.18.717-8.198 1.674 8.407 1.878.164 3.108-7.988-.717 8.197 2.05.18 1.045-11.955-2.988-.261-3.108 7.988-1.674-8.407-2.989-.261zM213.66 226.95l8.87 1.524.348-2.028-6.843-1.175.465-2.704 5.575.958.348-2.027-5.575-.958.32-1.859 6.63 1.14.35-2.028-8.66-1.487z" />
				<path
					d="m394.523-1651.318 12.586 3.255 6.51-25.171 27.108 7.01a22 22 0 0 0 11.017-42.598l-38.726-10.016zm22.351-34.502 26.14 6.76a9 9 0 0 0 4.507-17.427l-26.14-6.76z"
					style={{
						fillRule: 'evenodd',
					}}
					transform="matrix(.17143 0 0 .17143 168.814 514.508)"
				/>
				<path
					d="M-31.5 0h13v-26h28a22 22 0 0 0 0-44h-40zm13-39h27a9 9 0 0 0 0-18h-27z"
					style={{
						fillRule: 'evenodd',
					}}
					transform="rotate(17.502 -641.65 951.175) scale(.17143)"
				/>
				<path d="M260.897 238.42c.515-1.635 1.65-5.232-.803-6.005l-3.106-.98c3.596 1.135 2.462 4.732 1.947 6.367" />
				<path
					d="M594.477-1590.001a31.5 35 20.5 0 0 24.515-65.567 31.5 35 20.5 0 0-24.515 65.567m4.553-12.177a18.5 22 20.5 0 0 15.409-41.213 18.5 22 20.5 0 0-15.41 41.213"
					style={{
						fillRule: 'evenodd',
					}}
					transform="matrix(.17143 0 0 .17143 168.814 514.508)"
				/>
				<path
					d="M0 0a31.5 35 0 0 0 0-70A31.5 35 0 0 0 0 0m0-13a18.5 22 0 0 0 0-44 18.5 22 0 0 0 0 44"
					style={{
						fillRule: 'evenodd',
					}}
					transform="rotate(23.501 -452.858 808.568) scale(.17143)"
				/>
				<path d="m288.028 242.483 4.166 1.812-.683 1.572-4.166-1.811z" />
				<path d="m290.622 243.611 1.572.684-2.392 5.502-1.572-.683z" />
				<path
					d="M-31.5 0h13v-26h28a22 22 0 0 0 0-44h-40zm13-39h27a9 9 0 0 0 0-18h-27z"
					style={{
						fillRule: 'evenodd',
					}}
					transform="rotate(26.501 -390.185 761.227) scale(.17143)"
				/>
				<path d="M302.953 256.224c.765-1.534 2.448-4.909.146-6.056l-2.915-1.454c3.376 1.683 1.693 5.058.928 6.592M307.409 258.576l9.4 5.318 1.097-1.94-7.61-4.305 1.52-2.685 5.968 3.376 1.013-1.79-5.968-3.377 1.182-2.089 7.162 4.052 1.097-1.94-8.952-5.064zM324.917 264.45c-.645 1.012.009 2.14 1.455 3.061 1.445.921 2.43.888 2.846.238 1.313-2.06-6.276-5.065-3.937-8.657 2.017-3.085 5.467-.684 6.768.145 1.301.83 3.39 2.973 1.766 5.444l-2.205-1.404c.69-1.085-.068-2.127-1.225-2.864-1.12-.714-2.03-1.04-2.698.009-1.119 1.675 6.318 4.838 4.038 8.416-1.68 2.639-4.605 1.487-6.557.244-1.663-1.06-4.147-3.557-2.528-6.083zM337.79 272.963c-.697.977-.103 2.137 1.292 3.132 1.396.996 2.381 1.014 2.83.387 1.42-1.989-6.001-5.386-3.478-8.85 2.175-2.976 5.495-.398 6.751.498 1.256.896 3.23 3.147 1.479 5.53l-2.129-1.519c.747-1.047.044-2.127-1.073-2.924-1.081-.771-1.973-1.144-2.695-.132-1.205 1.615 6.056 5.162 3.593 8.616-1.817 2.547-4.678 1.244-6.562-.1-1.605-1.145-3.955-3.769-2.206-6.206z" />
				<path
					d="M1056.719-1328.477a31.5 35 38.5 0 0 43.576-54.783 31.5 35 38.5 0 0-43.576 54.783m8.092-10.174a18.5 22 38.5 0 0 27.39-34.435 18.5 22 38.5 0 0-27.39 34.435"
					style={{
						fillRule: 'evenodd',
					}}
					transform="matrix(.17143 0 0 .17143 168.814 514.508)"
				/>
			</g>
			<g
				style={{
					fill: '#fff',
				}}
			>
				<path d="m137.956 234.48-1.668 5.136 2.568.834" />
				<path d="m137.956 234.48 1.67 5.136-2.569.834" />
				<path d="M143.092 238.211h-5.4v2.7" />
				<path d="m143.092 238.211-4.369 3.174-1.587-2.184" />
				<path d="m132.82 238.211 4.37 3.174 1.586-2.184" />
				<path d="M132.82 238.211h5.4v2.7" />
				<path d="m141.13 244.249-1.668-5.136-2.568.834" />
				<path d="m141.13 244.249-4.368-3.174 1.587-2.185" />
				<path d="m134.782 244.249 4.37-3.174-1.588-2.185" />
				<path d="m134.782 244.249 1.67-5.136 2.567.834" />
			</g>
			<g
				style={{
					fill: '#fff',
				}}
			>
				<path d="m149.1 287.451-1.67 5.136 2.568.834" />
				<path d="m149.1 287.451 1.668 5.136-2.568.834" />
				<path d="M154.235 291.183h-5.4v2.7" />
				<path d="m154.235 291.183-4.369 3.174-1.587-2.185" />
				<path d="m143.964 291.183 4.368 3.174 1.587-2.185" />
				<path d="M143.964 291.183h5.4v2.7" />
				<path d="m152.273 297.22-1.668-5.136-2.568.835" />
				<path d="m152.273 297.22-4.368-3.174 1.587-2.184" />
				<path d="m145.925 297.22 4.369-3.174-1.587-2.184" />
				<path d="m145.925 297.22 1.669-5.136 2.568.835" />
			</g>
			<g
				style={{
					fill: '#fff',
				}}
			>
				<path d="m133.67 299.666-1.39 4.28 2.14.695" />
				<path d="m133.67 299.666 1.391 4.28-2.14.695" />
				<path d="M137.95 302.775h-4.5v2.25" />
				<path d="m137.95 302.775-3.64 2.645-1.323-1.82" />
				<path d="m129.39 302.775 3.642 2.645 1.322-1.82" />
				<path d="M129.39 302.775h4.5v2.25" />
				<path d="m136.316 307.806-1.39-4.28-2.14.696" />
				<path d="m136.316 307.806-3.64-2.645 1.322-1.82" />
				<path d="m131.026 307.806 3.64-2.645-1.322-1.82" />
				<path d="m131.026 307.806 1.39-4.28 2.14.696" />
			</g>
			<g
				style={{
					fill: '#fff',
				}}
			>
				<path d="m161.442 282.566-.794 2.445 1.222.397" />
				<path d="m161.442 282.566.795 2.445-1.223.397" />
				<path d="M163.888 284.342h-2.572v1.286" />
				<path d="m163.888 284.342-2.08 1.512-.756-1.04" />
				<path d="m158.997 284.342 2.08 1.512.756-1.04" />
				<path d="M158.997 284.342h2.571v1.286" />
				<path d="m162.954 287.217-.795-2.445-1.223.397" />
				<path d="m162.954 287.217-2.08-1.511.755-1.04" />
				<path d="m159.93 287.217 2.081-1.511-.756-1.04" />
				<path d="m159.93 287.217.795-2.445 1.223.397" />
			</g>
			<g
				style={{
					fill: '#fff',
				}}
			>
				<path d="m175.328 300.866-1.39 4.28 2.14.695" />
				<path d="m175.328 300.866 1.39 4.28-2.14.695" />
				<path d="M179.608 303.975h-4.5v2.25" />
				<path d="m179.608 303.975-3.641 2.645-1.322-1.82" />
				<path d="m171.048 303.975 3.64 2.645 1.323-1.82" />
				<path d="M171.048 303.975h4.5v2.25" />
				<path d="m177.973 309.006-1.39-4.28-2.14.696" />
				<path d="m177.973 309.006-3.64-2.645 1.322-1.82" />
				<path d="m172.683 309.006 3.64-2.645-1.322-1.82" />
				<path d="m172.683 309.006 1.39-4.28 2.14.696" />
			</g>
			<g
				style={{
					fill: '#fff',
				}}
			>
				<path d="m171.556 314.28-1.112 3.424 1.712.556" />
				<path d="m171.556 314.28 1.113 3.424-1.712.556" />
				<path d="M174.98 316.767h-3.6v1.8" />
				<path d="m174.98 316.767-2.912 2.116-1.058-1.456" />
				<path d="m168.133 316.767 2.912 2.116 1.058-1.456" />
				<path d="M168.133 316.767h3.6v1.8" />
				<path d="m173.672 320.792-1.112-3.423-1.712.556" />
				<path d="m173.672 320.792-2.912-2.116 1.058-1.456" />
				<path d="m169.44 320.792 2.913-2.116-1.058-1.456" />
				<path d="m169.44 320.792 1.113-3.423 1.712.556" />
			</g>
			<g
				style={{
					fill: '#fff',
				}}
			>
				<path d="m279.9 218.023-1.67 5.135 2.568.835" />
				<path d="m279.9 218.023 1.668 5.135-2.568.835" />
				<path d="M285.035 221.754h-5.4v2.7" />
				<path d="m285.035 221.754-4.369 3.174-1.587-2.184" />
				<path d="m274.764 221.754 4.368 3.174 1.587-2.184" />
				<path d="M274.764 221.754h5.4v2.7" />
				<path d="m283.073 227.791-1.668-5.135-2.568.834" />
				<path d="m283.073 227.791-4.368-3.174 1.587-2.184" />
				<path d="m276.725 227.791 4.369-3.174-1.587-2.184" />
				<path d="m276.725 227.791 1.669-5.135 2.568.834" />
			</g>
			<g
				style={{
					fill: '#fff',
				}}
			>
				<path d="m329.1 301.337-1.67 5.136 2.568.834" />
				<path d="m329.1 301.337 1.668 5.136-2.568.834" />
				<path d="M334.235 305.068h-5.4v2.7" />
				<path d="m334.235 305.068-4.369 3.174-1.587-2.184" />
				<path d="m323.964 305.068 4.368 3.174 1.587-2.184" />
				<path d="M323.964 305.068h5.4v2.7" />
				<path d="m332.273 311.106-1.668-5.136-2.568.834" />
				<path d="m332.273 311.106-4.368-3.174 1.587-2.185" />
				<path d="m325.925 311.106 4.369-3.174-1.587-2.185" />
				<path d="m325.925 311.106 1.669-5.136 2.568.834" />
			</g>
			<g
				style={{
					fill: '#fff',
				}}
			>
				<path d="m346.585 304.337-1.112 3.424 1.711.556" />
				<path d="m346.585 304.337 1.112 3.424-1.711.556" />
				<path d="M350.009 306.825h-3.6v1.8" />
				<path d="m350.009 306.825-2.913 2.116-1.058-1.457" />
				<path d="m343.161 306.825 2.913 2.116 1.058-1.457" />
				<path d="M343.161 306.825h3.6v1.8" />
				<path d="m348.701 310.85-1.112-3.424-1.712.556" />
				<path d="m348.701 310.85-2.912-2.117 1.058-1.456" />
				<path d="m344.469 310.85 2.912-2.117-1.058-1.456" />
				<path d="m344.469 310.85 1.112-3.424 1.712.556" />
			</g>
			<g
				style={{
					fill: '#fff',
				}}
			>
				<path d="m334.242 313.38-1.39 4.28 2.14.695" />
				<path d="m334.242 313.38 1.39 4.28-2.14.695" />
				<path d="M338.522 316.49h-4.5v2.25" />
				<path d="m338.522 316.49-3.64 2.644-1.323-1.82" />
				<path d="m329.962 316.49 3.641 2.644 1.322-1.82" />
				<path d="M329.962 316.49h4.5v2.25" />
				<path d="m336.887 321.52-1.39-4.28-2.14.696" />
				<path d="m336.887 321.52-3.64-2.645 1.322-1.82" />
				<path d="m331.597 321.52 3.64-2.645-1.322-1.82" />
				<path d="m331.597 321.52 1.39-4.28 2.14.696" />
			</g>
			<g
				style={{
					fill: '#fff',
				}}
			>
				<path d="m303.9 339.78-1.391 4.28 2.14.695" />
				<path d="m303.9 339.78 1.39 4.28-2.14.695" />
				<path d="M308.179 342.89h-4.5v2.25" />
				<path d="m308.179 342.89-3.64 2.644-1.323-1.82" />
				<path d="m299.62 342.89 3.64 2.644 1.323-1.82" />
				<path d="M299.62 342.89h4.5v2.25" />
				<path d="m306.544 347.92-1.39-4.28-2.14.696" />
				<path d="m306.544 347.92-3.64-2.645 1.322-1.82" />
				<path d="m301.254 347.92 3.64-2.645-1.322-1.82" />
				<path d="m301.254 347.92 1.39-4.28 2.14.696" />
			</g>
			<g
				style={{
					fill: '#fff',
				}}
			>
				<path d="m303.728 353.366-1.113 3.423 1.712.557" />
				<path d="m303.728 353.366 1.112 3.423-1.712.557" />
				<path d="M307.152 355.853h-3.6v1.8" />
				<path d="m307.152 355.853-2.913 2.116-1.058-1.456" />
				<path d="m300.304 355.853 2.913 2.116 1.058-1.456" />
				<path d="M300.304 355.853h3.6v1.8" />
				<path d="m305.844 359.878-1.113-3.424-1.711.556" />
				<path d="m305.844 359.878-2.913-2.116 1.058-1.456" />
				<path d="m301.612 359.878 2.912-2.116-1.058-1.456" />
				<path d="m301.612 359.878 1.112-3.424 1.712.556" />
			</g>
			<g
				style={{
					fill: '#fff',
				}}
			>
				<path d="m316.414 330.737-1.113 3.424 1.712.556" />
				<path d="m316.414 330.737 1.112 3.424-1.712.556" />
				<path d="M319.837 333.225h-3.6v1.8" />
				<path d="m319.837 333.225-2.912 2.116-1.058-1.457" />
				<path d="m312.99 333.225 2.912 2.116 1.058-1.457" />
				<path d="M312.99 333.225h3.6v1.8" />
				<path d="m318.53 337.25-1.113-3.424-1.712.556" />
				<path d="m318.53 337.25-2.913-2.117 1.058-1.456" />
				<path d="m314.298 337.25 2.912-2.117-1.058-1.456" />
				<path d="m314.298 337.25 1.112-3.424 1.712.556" />
			</g>
			<g
				style={{
					fill: '#fff',
				}}
			>
				<path d="m326.528 323.494-1.39 4.28 2.14.695" />
				<path d="m326.528 323.494 1.39 4.28-2.14.695" />
				<path d="M330.808 326.604h-4.5v2.25" />
				<path d="m330.808 326.604-3.641 2.645-1.322-1.82" />
				<path d="m322.248 326.604 3.64 2.645 1.323-1.82" />
				<path d="M322.248 326.604h4.5v2.25" />
				<path d="m329.173 331.635-1.39-4.28-2.14.695" />
				<path d="m329.173 331.635-3.64-2.645 1.322-1.82" />
				<path d="m323.883 331.635 3.64-2.645-1.322-1.82" />
				<path d="m323.883 331.635 1.39-4.28 2.14.695" />
			</g>
			<g
				style={{
					fill: '#fff',
				}}
			>
				<path d="m303.385 328.337-1.112 3.424 1.711.556" />
				<path d="m303.385 328.337 1.112 3.424-1.711.556" />
				<path d="M306.809 330.825h-3.6v1.8" />
				<path d="m306.809 330.825-2.913 2.116-1.058-1.457" />
				<path d="m299.961 330.825 2.913 2.116 1.058-1.457" />
				<path d="M299.961 330.825h3.6v1.8" />
				<path d="m305.501 334.85-1.112-3.424-1.712.556" />
				<path d="m305.501 334.85-2.912-2.117 1.058-1.456" />
				<path d="m301.269 334.85 2.912-2.117-1.058-1.456" />
				<path d="m301.269 334.85 1.112-3.424 1.712.556" />
			</g>
			<g
				style={{
					fill: '#fff',
				}}
			>
				<path d="m192.814 263.151-1.391 4.28 2.14.695" />
				<path d="m192.814 263.151 1.39 4.28-2.14.695" />
				<path d="M197.093 266.26h-4.5v2.25" />
				<path d="m197.093 266.26-3.64 2.646-1.323-1.82" />
				<path d="m188.534 266.26 3.64 2.646 1.323-1.82" />
				<path d="M188.534 266.26h4.5v2.25" />
				<path d="m195.459 271.292-1.391-4.28-2.14.695" />
				<path d="m195.459 271.292-3.641-2.645 1.323-1.82" />
				<path d="m190.169 271.292 3.64-2.645-1.322-1.82" />
				<path d="m190.169 271.292 1.39-4.28 2.14.695" />
			</g>
			<g
				style={{
					fill: '#fff',
				}}
			>
				<path d="m275.1 252.566-1.113 3.423 1.712.557" />
				<path d="m275.1 252.566 1.112 3.423-1.712.557" />
				<path d="M278.523 255.053h-3.6v1.8" />
				<path d="m278.523 255.053-2.912 2.116-1.058-1.456" />
				<path d="m271.675 255.053 2.913 2.116 1.058-1.456" />
				<path d="M271.675 255.053h3.6v1.8" />
				<path d="m277.215 259.078-1.112-3.424-1.712.556" />
				<path d="m277.215 259.078-2.912-2.116 1.058-1.456" />
				<path d="m272.983 259.078 2.913-2.116-1.058-1.456" />
				<path d="m272.983 259.078 1.113-3.424 1.712.556" />
			</g>
			<g
				style={{
					fill: '#fff',
				}}
			>
				<path d="m240.814 313.68-1.67 5.136 2.569.834" />
				<path d="m240.814 313.68 1.668 5.136-2.568.834" />
				<path d="M245.95 317.411h-5.4v2.7" />
				<path d="m245.95 317.411-4.37 3.174-1.586-2.184" />
				<path d="m235.678 317.411 4.369 3.174 1.587-2.184" />
				<path d="M235.678 317.411h5.4v2.7" />
				<path d="m243.988 323.449-1.67-5.136-2.567.834" />
				<path d="m243.988 323.449-4.37-3.174 1.588-2.185" />
				<path d="m237.64 323.449 4.368-3.174-1.587-2.185" />
				<path d="m237.64 323.449 1.668-5.136 2.568.834" />
			</g>
			<g
				style={{
					fill: '#fff',
				}}
			>
				<path d="m255.385 289.551-1.39 4.28 2.14.695" />
				<path d="m255.385 289.551 1.39 4.28-2.14.695" />
				<path d="M259.665 292.66h-4.5v2.25" />
				<path d="m259.665 292.66-3.64 2.646-1.323-1.82" />
				<path d="m251.105 292.66 3.64 2.646 1.323-1.82" />
				<path d="M251.105 292.66h4.5v2.25" />
				<path d="m258.03 297.692-1.39-4.28-2.14.695" />
				<path d="m258.03 297.692-3.64-2.645 1.322-1.82" />
				<path d="m252.74 297.692 3.64-2.645-1.322-1.82" />
				<path d="m252.74 297.692 1.39-4.28 2.14.695" />
			</g>
			<g
				style={{
					fill: '#fff',
				}}
			>
				<path d="m240.814 278.237-1.391 4.28 2.14.695" />
				<path d="m240.814 278.237 1.39 4.28-2.14.695" />
				<path d="M245.093 281.346h-4.5v2.25" />
				<path d="m245.093 281.346-3.64 2.645-1.323-1.82" />
				<path d="m236.534 281.346 3.64 2.645 1.323-1.82" />
				<path d="M236.534 281.346h4.5v2.25" />
				<path d="m243.459 286.378-1.391-4.28-2.14.695" />
				<path d="m243.459 286.378-3.641-2.645 1.323-1.82" />
				<path d="m238.169 286.378 3.64-2.645-1.322-1.82" />
				<path d="m238.169 286.378 1.39-4.28 2.14.695" />
			</g>
			<g
				style={{
					fill: '#fff',
				}}
			>
				<path d="m228.128 290.451-1.113 3.424 1.712.556" />
				<path d="m228.128 290.451 1.112 3.424-1.712.556" />
				<path d="M231.552 292.939h-3.6v1.8" />
				<path d="m231.552 292.939-2.913 2.116-1.058-1.456" />
				<path d="m224.704 292.939 2.913 2.116 1.058-1.456" />
				<path d="M224.704 292.939h3.6v1.8" />
				<path d="m230.244 296.964-1.113-3.424-1.711.556" />
				<path d="m230.244 296.964-2.913-2.116 1.058-1.456" />
				<path d="m226.012 296.964 2.912-2.116-1.058-1.456" />
				<path d="m226.012 296.964 1.112-3.424 1.712.556" />
			</g>
			<g
				style={{
					fill: '#fff',
				}}
			>
				<path d="m234.47 300.223-.794 2.445 1.223.398" />
				<path d="m234.47 300.223.795 2.445-1.222.398" />
				<path d="M236.916 302h-2.571v1.285" />
				<path d="m236.916 302-2.08 1.511-.756-1.04" />
				<path d="m232.025 302 2.08 1.511.756-1.04" />
				<path d="M232.025 302h2.572v1.285" />
				<path d="m235.982 304.875-.794-2.446-1.223.397" />
				<path d="m235.982 304.875-2.08-1.512.756-1.04" />
				<path d="m232.96 304.875 2.08-1.512-.756-1.04" />
				<path d="m232.96 304.875.794-2.446 1.223.397" />
			</g>
			<g
				style={{
					fill: '#fff',
				}}
			>
				<path d="m278.528 342.866-1.39 4.28 2.14.695" />
				<path d="m278.528 342.866 1.39 4.28-2.14.695" />
				<path d="M282.808 345.975h-4.5v2.25" />
				<path d="m282.808 345.975-3.641 2.645-1.322-1.82" />
				<path d="m274.248 345.975 3.64 2.645 1.323-1.82" />
				<path d="M274.248 345.975h4.5v2.25" />
				<path d="m281.173 351.006-1.39-4.28-2.14.696" />
				<path d="m281.173 351.006-3.64-2.645 1.322-1.82" />
				<path d="m275.883 351.006 3.64-2.645-1.322-1.82" />
				<path d="m275.883 351.006 1.39-4.28 2.14.696" />
			</g>
			<g
				style={{
					fill: '#fff',
				}}
			>
				<path d="m289.328 332.623-1.113 3.424 1.712.556" />
				<path d="m289.328 332.623 1.112 3.424-1.712.556" />
				<path d="M292.752 335.11h-3.6v1.8" />
				<path d="m292.752 335.11-2.913 2.116-1.058-1.456" />
				<path d="m285.904 335.11 2.913 2.116 1.058-1.456" />
				<path d="M285.904 335.11h3.6v1.8" />
				<path d="m291.444 339.135-1.113-3.424-1.711.557" />
				<path d="m291.444 339.135-2.913-2.116 1.058-1.456" />
				<path d="m287.212 339.135 2.912-2.116-1.058-1.456" />
				<path d="m287.212 339.135 1.112-3.424 1.712.557" />
			</g>
			<g
				style={{
					fill: '#fff',
				}}
			>
				<path d="m268.585 329.537-1.112 3.424 1.711.556" />
				<path d="m268.585 329.537 1.112 3.424-1.711.556" />
				<path d="M272.009 332.025h-3.6v1.8" />
				<path d="m272.009 332.025-2.913 2.116-1.058-1.457" />
				<path d="m265.161 332.025 2.913 2.116 1.058-1.457" />
				<path d="M265.161 332.025h3.6v1.8" />
				<path d="m270.701 336.05-1.112-3.424-1.712.556" />
				<path d="m270.701 336.05-2.912-2.117 1.058-1.456" />
				<path d="m266.469 336.05 2.912-2.117-1.058-1.456" />
				<path d="m266.469 336.05 1.112-3.424 1.712.556" />
			</g>
			<g
				style={{
					fill: '#fff',
				}}
			>
				<path d="m190.242 323.966-1.669 5.135 2.568.835" />
				<path d="m190.242 323.966 1.669 5.135-2.568.835" />
				<path d="M195.378 327.697h-5.4v2.7" />
				<path d="m195.378 327.697-4.369 3.174-1.587-2.184" />
				<path d="m185.106 327.697 4.37 3.174 1.586-2.184" />
				<path d="M185.106 327.697h5.4v2.7" />
				<path d="m193.416 333.734-1.669-5.135-2.567.834" />
				<path d="m193.416 333.734-4.369-3.174 1.587-2.184" />
				<path d="m187.068 333.734 4.369-3.174-1.587-2.184" />
				<path d="m187.068 333.734 1.669-5.135 2.568.834" />
			</g>
			<g
				style={{
					fill: '#fff',
				}}
			>
				<path d="m240.814 359.28-.557 1.712.856.278" />
				<path d="m240.814 359.28.556 1.712-.856.278" />
				<path d="M242.525 360.524h-1.8v.9" />
				<path d="m242.525 360.524-1.456 1.058-.529-.728" />
				<path d="m239.102 360.524 1.456 1.058.529-.728" />
				<path d="M239.102 360.524h1.8v.9" />
				<path d="m241.872 362.536-.557-1.712-.856.278" />
				<path d="m241.872 362.536-1.457-1.058.53-.728" />
				<path d="m239.756 362.536 1.456-1.058-.53-.728" />
				<path d="m239.756 362.536.556-1.712.856.278" />
			</g>
		</g>
	</svg>
);
export default FlagBR;
